import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { FiArrowLeft } from 'react-icons/fi';

import giveahandLogo from '~/assets/logo.png';

import colors from '~/styles/colors';

import {
  Container,
  Content,
  RegisterWrapper,
  BackLink,
  FormWrapper,
  InputWrapper,
  InputPhoneWrapper,
  Button,
} from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function NewIncident() {
  const formRef = useRef(null);

  const respId = localStorage.getItem('respId');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Give a Hand | New Indication';
  });

  async function handleNewIncident(data, { reset }) {
    try {
      setLoading(true);

      const schema = Yup.object().shape({
        indication_name: Yup.string().required(
          'O nome da indicação é obrigatório.'
        ),
        indication_position: Yup.string().required(
          'O cargo da indicação é obrigatório.'
        ),
        indication_email: Yup.string()
          .email('Insira um e-mail válido.')
          .required('O e-mail da indicação é obrigatório.'),
        indication_whatsapp: Yup.string()
          .required('O WhatsApp da indicação é obrigatório.')
          .min(13, 'Insira um WhatsApp válido.')
          .max(14, 'Insira um WhatsApp válido.'),
        indication_linkedin: Yup.string().required(
          'O LinkedIn da indicação é obrigatório.'
        ),
        indication_city: Yup.string().required(
          'A cidade da indicação é obrigatória.'
        ),
        indication_state: Yup.string().required(
          'O estado da indicação é obrigatório.'
        ),
        indication_city_interest: Yup.string().required(
          'A cidade de interesse da indicação é obrigatória.'
        ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      formRef.current.setErrors({});

      await api.post('/indications', data, {
        headers: {
          Authorization: respId,
        },
      });

      toast.success('Nova indicação cadastrada com sucesso.');

      history.push('/profile');
    } catch (err) {
      setLoading(false);

      if (err instanceof Yup.ValidationError) {
        // console.log(err);

        const errorMessages = {};

        err.inner.forEach(error => {
          errorMessages[error.path] = error.message;
        });

        formRef.current.setErrors(errorMessages);
      }
    }
  }

  return (
    <Container>
      <Content>
        <RegisterWrapper>
          <img src={giveahandLogo} alt="Give A Hand" />
          <h1>Cadastrar uma nova indicação</h1>
          <p>
            Cadastre as informações da pessoa que está precisando de uma
            realocação / indicação de <strong>urgência</strong>. Lembre-se do{' '}
            <strong>bom senso</strong> ao cadastrar informações de terceiros 😊.
          </p>
          <BackLink to="/profile">
            <FiArrowLeft size={16} color={colors.danger} />
            Voltar para home
          </BackLink>
        </RegisterWrapper>
        <FormWrapper>
          <Form ref={formRef} onSubmit={handleNewIncident}>
            <InputWrapper
              autoFocus
              name="indication_name"
              placeholder="Nome completo"
            />

            <InputWrapper name="indication_position" placeholder="Cargo" />

            <InputWrapper
              name="indication_email"
              type="email"
              placeholder="E-mail"
            />

            <InputPhoneWrapper
              name="indication_whatsapp"
              placeholder="Número do WhatsApp"
              mask="(99) 9999tt999?"
              formatChars={{ '9': '[0-9]', t: '[0-9-]', '?': '[0-9 ]' }}
              maskChar={null}
            />

            <InputWrapper
              type="url"
              name="indication_linkedin"
              placeholder="Link do LinkedIn"
            />

            <InputWrapper name="indication_city" placeholder="Cidade" />

            <InputWrapper name="indication_state" placeholder="Estado" />

            <InputWrapper
              name="indication_city_interest"
              placeholder="Cidade com interesse em atuar"
            />

            <Button>{loading ? 'Cadastrando...' : 'Cadastrar'}</Button>
          </Form>
        </FormWrapper>
      </Content>
    </Container>
  );
}
